import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { B3SelectItem } from 'src/app/shared/models/b3-select-item.model';
import { ValidateTwoValueInString, ValidateValueInString } from 'src/app/helpers/Validators/specific-value-in-string-validator';
import { emissionDateNotAfterSafraStartValidator } from 'src/app/helpers/Validators/emission-date.validator';
import { CarbonCreditRequest, CarbonCreditResponse } from 'src/app/shared/interfaces/carbon-credit-request';
import { CreditRegisterService } from './service/credit-register.service';
import { CarbonCertifiersService } from './service/carbon-certifiers.service';
import { MenuService } from 'src/app/components/menu/service/menu.service';
import { LoggedInService } from 'src/app/services/auth/loggedin.service';
import { CpfCnpjValidator } from 'src/app/helpers/Validators/CpfCnpjValidator/cpf-cnpj.validator';
import { comitenteBackendValidator } from 'src/app/helpers/Validators/ComitenteValidatorBackend/comitente-backend.validator';
import {
  extractDocumentCharacters,
  formatCNPJProgressive,
  formatCpfCnpjInputValue,
} from 'src/app/helpers/utils/cpf-cnpj.util';
import { firstValueFrom } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import {
  buildCreditRegisterSuccessViewModel,
  CreditRegisterErrorViewModel,
  CreditRegisterInfoViewModel,
  CreditRegisterSuccessFlow,
  CreditRegisterSuccessViewModel,
} from './modals/credit-register-modal.model';

@Component({
  standalone: false,
  selector: 'app-credit-register',
  templateUrl: './credit-register.component.html',
  styleUrls: ['./credit-register.component.scss']
})
export class CreditRegisterComponent implements OnInit {

  public errorMsg = "Data inválida ou não preenchida";
  public formRegister: FormGroup = new FormGroup({});
  public today = new Date();
  public maxDate: Date;
  public minDate: Date;
  public maxSafraIDate: Date | null = null;
  public minSafraFDate: Date | null = null;
  public certifiers: any[] = [];

  characterCount: number = 0;
  showHolderCpfCnpj: boolean = false;
  comitenteFound = false;

  selectItens: B3SelectItem[] = [];
  selectedItem: B3SelectItem = { inputId: 0, label: '', data: '' };

  //registry date
  defaultRegistryDate: boolean = true;
  isInvalidRegistryDate: boolean = false;

  registrationStartDate: Date = new Date();
  defaultStartDate: boolean = true;
  invalidStartDate: boolean = false;

  registrationEndDate: Date = new Date();
  defaultEndDate: boolean = true;
  invalidEndDate: boolean = false;


  isButtonDisabled: boolean = false;
  isCdmCertifierSelected = false;

  showSuccessModal = false;
  successViewModel: CreditRegisterSuccessViewModel | null = null;

  showErrorModal = false;
  errorViewModel: CreditRegisterErrorViewModel | null = null;

  showInfoModal = false;
  infoViewModel: CreditRegisterInfoViewModel | null = null;

  private readonly consultRoute = '/consulta-operacoes';

  public msgProjectIdInvalid = "";
  public msgVerraVintageStartInvalid = "";
  public msgVerraVintageEndInvalid = "";
  public msgInvalidSerialBlock = "Serial Range/Credit ID é Inválido para esta Certificadora";
  public isValidSerialCode: boolean = true;

  private readonly excludedCertifierCodes = [
    'americancarbonregistry',
    'psacarbonflor',
    'psacarbonagroperene',
  ];
  private readonly excludedCertifierNames = [
    'PSA Carbonflor',
    'PSA Carbon Agro Perene',
  ];

  private patternRegexSerialCodeVerra: string = "^\\w+-(?<serialStart>\\w+)-(?<serialEnd>\\w+)-\\w+-\\w+-\\w+-\\w+-(?<country>\\w+)-\\w+-(?<projectId>\\w+)-(?<vintageStart>\\w+)-(?<vintageEnd>\\w+)-\\w+$";
  private patternRegexSerialCodeGoldStandard: string = "^\\w+-\\w+-(?<country>\\w+)-(?<projectId>\\w+)-\\w+-(?<vintage>\\w+)-\\w+-(?<serialStart>\\w+)-(?<serialEnd>\\w+)$";

  private static readonly HOLDER_ACCOUNT_TYPE_ACX = '10';
  private static readonly ACX_BLOCKED_CERTIFIER_CODES = new Set(['verra', 'goldstandard']);
  private static readonly ACX_BLOCKED_CERTIFIER_IDS = new Set([2, 3]);
  private static readonly CDM_CERTIFIER_ID = 15;
  private static readonly CDM_CERTIFIER_DISPLAY_NAME = 'Mecanismo de Desenvolvimento Limpo - MDL';
  private static readonly ACX_ACCOUNT_TYPE_NOT_AVAILABLE_MESSAGE =
    'Operação não permitida! Por favor, utilize uma conta detentor do tipo PRÓPRIA (00) e tente novamente.';
  private static readonly CDM_ACCOUNT_TYPE_NOT_AVAILABLE_MESSAGE =
    'Registro CDM com conta 10 permitido apenas para usuário B3.';
  private static readonly INVESTOR_NOT_FOUND_MESSAGE =
    'O comitente com este CPF/CNPJ não foi encontrado na modalidade "COMITENTE COMPLETO" para esta conta. Por favor, verifique os dados e tente novamente.';
  private static readonly INVALID_SERIAL_RANGE_MESSAGE =
    'Insira um serial range no padrão Verra ou Goldstandard';

  private static readonly INVALID_SERIAL_RANGE_DETAIL_KEYWORDS = [
    'serial',
    'block',
    'range',
    'verra',
    'goldstandard',
  ];

  private static readonly CDM_CERTIFIER_CODES = new Set(['cdm']);

  private lastRegistrationWasCdm = false;

  public DEFAULT_ERROR_MESSAGE = 'O envio das informações {0} falhou. Por favor, selecione uma das opções abaixo para tentar novamente ou acionar o suporte técnico da B3';

  public ERROR_MESSAGES: { [key: string]: string } = {};

  // Mensagens de erro por validação de campo
  public FIELD_ERROR_MESSAGES: { [key: string]: string } = {
    "holderCpfCnpj": CreditRegisterComponent.INVESTOR_NOT_FOUND_MESSAGE,
    "cnpj": "Insira um CNPJ válido",
    "registerNumber": "Insira uma conta miolo (40) válida",
    "holderNumber": "Insira uma conta miolo (00) ou miolo (10)",
    "serialCode": "O Serial Range/Credit ID é inválido para esta certificadora.",
    "projectId": "O ID do projeto não corresponde ao Serial Range informado.",
    "data": "A data de emissão é inválida.",
    "safraIDate": "A data de início da safra é inválida.",
    "safraFDate": "A data de término da safra é inválida.",
  };

  constructor(
    private formBuilder: FormBuilder,
    private creditRegisterService: CreditRegisterService,
    private carbonCertifiersService: CarbonCertifiersService,
    private menuService: MenuService,
    private loggedInService: LoggedInService,
    private location: Location,
    private router: Router
  ) {
    const currentYear = new Date().getFullYear();
    this.maxDate = new Date(currentYear, 11, 31);
    this.minDate = new Date(1992, 0, 1);

    this.ERROR_MESSAGES = {
      "SerialCodeAlreadyExists": "Serial Range/Credit ID já Registrado",
      "CarbonCreditRegisterError": "O envio das informações falhou. Por favor, tente novamente ou acione o suporte técnico da B3.",
      "CommunicationErrorAcx": "Erro na comunicação com a ACX. Por favor, tente novamente ou acione o suporte técnico da B3.",
      "CommunicationErrorMdl": "Erro na comunicação com o MDL (CDM). Por favor, tente novamente ou acione o suporte técnico da B3.",
      "InvestorNotFound": CreditRegisterComponent.INVESTOR_NOT_FOUND_MESSAGE,
      "InvestorDocumentRequired": "CPF/CNPJ do comitente é obrigatório para conta detentor 10.",
      "CdmMiolo10RegistrationNotAllowed": CreditRegisterComponent.CDM_ACCOUNT_TYPE_NOT_AVAILABLE_MESSAGE,
    };
  }

  ngOnInit(): void {
    this.initFormRegister();
    this.waitForMenuLoadedAndLoadCertifiers();

    this.formRegister.get('description')?.valueChanges.subscribe(value => {
      this.characterCount = value?.length;
    });

    this.formRegister.get('cnpj')?.valueChanges.subscribe((value) => {
      this.syncRegistrarDocumentControlValue(value, this.shouldFormatRegistrarDocumentOnInput(value));
    });

    this.formRegister.get('holderNumber')?.valueChanges.subscribe(value => {
      this.applyHolderCpfCnpjValidators(value);
    });

    this.formRegister.get('holderCpfCnpj')?.statusChanges.subscribe(() => {
      this.updateComitenteFoundState();
    });

    this.formRegister.get('holderCpfCnpj')?.valueChanges.subscribe((value) => {
      this.syncHolderDocumentControlValue(value);
      const digitCount = extractDocumentCharacters(value).length;
      if (digitCount === 11 || digitCount === 14 || this.comitenteFound) {
        this.updateComitenteFoundState();
      }
    });

    this.formRegister.get('safraIDate')?.valueChanges.subscribe(value => {
      this.minSafraFDate = value;
      this.formRegister.get('data')?.updateValueAndValidity({ emitEvent: false });
    });

    this.formRegister.get('certifier')?.valueChanges.subscribe(value => {
      this.onChangeCertifier(value);
    });

    this.formRegister.get('serialCodeStart')?.valueChanges.subscribe(() => {
      this.syncSerialCodeFromParts();
    });

    this.formRegister.get('serialCodeEnd')?.valueChanges.subscribe(() => {
      this.syncSerialCodeFromParts();
    });
  }

  public initFormRegister(): void {
    this.formRegister = this.formBuilder.group({
      data: ['', [Validators.required, emissionDateNotAfterSafraStartValidator()]],
      safraIDate: ['', [Validators.required]],
      safraFDate: ['', [Validators.required]],
      registerNumber: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10), ValidateValueInString('40', 6, 7)]],
      holderNumber: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10), ValidateTwoValueInString('00', '10', 6, 7)]],
      holderCpfCnpj: ['', [CpfCnpjValidator.validate],
        [
          comitenteBackendValidator(
            this.creditRegisterService,
            () => this.formRegister.get('holderNumber')?.value
          )
        ]
      ],
      cnpj: ['', [Validators.required, CpfCnpjValidator.validateCnpjOnly]],
      serialCode: ['', [Validators.required, Validators.maxLength(100)]],
      creditQuantity: [0, [Validators.required, Validators.min(0), Validators.maxLength(7), Validators.minLength(1), Validators.pattern('^[1-9][0-9]*$')]],
      projectId: ['', [Validators.required, Validators.maxLength(20)]],
      projectName: ['', [Validators.required, Validators.maxLength(200)]],
      linkProject: ['', [Validators.required, Validators.maxLength(200), this.noWhitespaceValidator]],
      certifier: ['', [Validators.required, Validators.maxLength(100)]],
      description: ['', [Validators.required, Validators.maxLength(500)]],
      brcerAccepted: [false],
      aceiteAccepted: [false],
      serialCodeStart: [''],
      serialCodeEnd: [''],
    })
  }

  public checkHasError(fieldName: string, errorCode?: string): boolean {
    let field = this.formRegister.get(fieldName);
    if (field == null || !field.touched) {
      return false;
    }
    if (errorCode == null) {

      return field.invalid;
    }
    return field.hasError(errorCode);
  }

  get canSubmit(): boolean {
    return this.formRegister.valid && !this.formRegister.pending && !this.isButtonDisabled;
  }

  get registrarCnpjMask(): 'cnpj-alpha' {
    return 'cnpj-alpha';
  }

  /** Máscara livre durante digitação; formatação CPF/CNPJ ocorre no blur e via sync. */
  get holderDocumentMask(): 'text' {
    return 'text';
  }

  get minDateIso(): string {
    return this.toIsoDate(this.minDate);
  }

  get maxDateIso(): string {
    return this.toIsoDate(this.today);
  }

  get minSafraFDateIso(): string {
    return this.toIsoDate(this.minSafraFDate ?? this.minDate);
  }

  public checkDateFieldError(fieldName: string, errorCode: string): boolean {
    const field = this.formRegister.get(fieldName);
    if (field == null || !field.touched) {
      return false;
    }
    return field.hasError(errorCode);
  }

  public checkSerialRange(fieldName: string): boolean {

    const carbonCredit: CarbonCreditRequest = this.creditRegisterService.mapperCarbonCredit(this.formRegister.value);

    //Verra Serial Validation
    if (carbonCredit.certifierId == 2 && carbonCredit.serialCode !== null && carbonCredit.serialCode !== undefined) {
      return this.validateVerraSerialBlock(carbonCredit, fieldName);
    }

    //Gold Standard Serial Validation
    if (carbonCredit.certifierId == 3) {
      return this.validateGSSerialBlock(carbonCredit, fieldName);
    }

    return false;

  }

  protected validateGSSerialBlock(carbonCredit: CarbonCreditRequest, fieldName: string): boolean {

    let isInvalid: boolean = false;

    if (carbonCredit.serialCode != null && carbonCredit.serialCode != "" &&
      carbonCredit.projectId != null && carbonCredit.projectId != "") {

      let splitSerial = carbonCredit.serialCode.split('-');
      let projectId = (splitSerial[3] != undefined && splitSerial[3] != null) ? splitSerial[3] : '-';

      let field = this.formRegister.get(fieldName);

      if (carbonCredit.projectId != projectId && fieldName == 'projectId') {
        this.msgProjectIdInvalid = "O campo 'ID do projeto' deve ser igual ao valor {} que consta no Serial Range";
        field?.setErrors({
          invalidBySerialRange: true
        });
        this.msgProjectIdInvalid = this.msgProjectIdInvalid.replace('{}', projectId)
        isInvalid = true;
      }
    }

    return isInvalid;
  }

  protected validateVerraSerialBlock(carbonCredit: CarbonCreditRequest, fieldName: string): boolean {

    let isInvalid: boolean = false;

    if (carbonCredit.serialCode != null && carbonCredit.serialCode != "" &&
      carbonCredit.vintageStart != null && carbonCredit.vintageStart != "" &&
      carbonCredit.vintageEnd != null && carbonCredit.vintageEnd != "" &&
      carbonCredit.projectId != null && carbonCredit.projectId != "") {

      let splitSerial = carbonCredit.serialCode.split('-');
      let projectId = (splitSerial[9] != undefined && splitSerial[9] != null) ? splitSerial[9] : '-';
      let safraIDate = (splitSerial[10] != undefined && splitSerial[10] != null) ? splitSerial[10] : '00000000';
      let safraFDate = (splitSerial[11] != undefined && splitSerial[11] != null) ? splitSerial[11] : '00000000';
      let safraIDateParsed = this.convertDateFormat(safraIDate);
      let safraFDateParsed = this.convertDateFormat(safraFDate);

      let field = this.formRegister.get(fieldName);

      if (carbonCredit.projectId != projectId && fieldName == 'projectId') {
        this.msgProjectIdInvalid = "O campo 'ID do projeto' deve ser igual ao valor {} que consta no Serial Range";
        field?.setErrors({
          invalidBySerialRange: true
        });
        this.msgProjectIdInvalid = this.msgProjectIdInvalid.replace('{}', projectId)
        isInvalid = true;
      }

      if (carbonCredit.vintageStart != safraIDateParsed && fieldName == 'safraIDate') {
        this.msgVerraVintageStartInvalid = "O campo 'Início da Safra' deve ser igual ao valor {} que consta no Serial Range"
        field?.setErrors({
          invalidBySerialRange: true
        })
        this.msgVerraVintageStartInvalid = this.msgVerraVintageStartInvalid.replace('{}', safraIDate)
        isInvalid = true;
      }

      if (carbonCredit.vintageEnd != safraFDateParsed && fieldName == 'safraFDate') {
        this.msgVerraVintageEndInvalid = "O campo 'Término da Safra' deve ser igual ao valor {} que consta no Serial Range"
        field?.setErrors({
          invalidBySerialRange: true
        })
        this.msgVerraVintageEndInvalid = this.msgVerraVintageEndInvalid.replace('{}', safraFDate)
        isInvalid = true;
      }

    }

    return isInvalid;
  }

  protected validateSerialRangeByCertifier(): boolean {

    const carbonCredit: CarbonCreditRequest = this.creditRegisterService.mapperCarbonCredit(this.formRegister.value);

    if (carbonCredit.certifierId !== null && carbonCredit.certifierId !== undefined &&
      carbonCredit.serialCode !== null && carbonCredit.serialCode !== undefined && carbonCredit.serialCode !== "") {

      //Verra
      if (carbonCredit.certifierId === 2) {
        return !this.validateSerialCodeByRegex(carbonCredit.serialCode, this.patternRegexSerialCodeVerra);
      }

      // Gold Standard
      if (carbonCredit.certifierId === 3) {
        return !this.validateSerialCodeByRegex(carbonCredit.serialCode, this.patternRegexSerialCodeGoldStandard);
      }

    }

    return false;
  }

  checkDataError(errorCode: string) {
    let fieldDate = this.formRegister.get('data');

    if (fieldDate == null || !fieldDate.touched) {
      return false;
    }

    return fieldDate.hasError(errorCode) || this.formRegister.hasError(errorCode);
  }

  public updateCharacterCount(event: Event): void {
    const input = event.target as HTMLTextAreaElement;
    this.characterCount = input.value.length;
  }

  public loadCertifiers(): void {
    this.carbonCertifiersService.getCarbonCertifiers().subscribe({
      next: (response) => {
        this.certifiers = response.data.filter(
          (certifier: { certifierCode: string; certifierName: string }) =>
            !this.excludedCertifierCodes.includes(certifier.certifierCode) &&
            !this.excludedCertifierNames.includes(certifier.certifierName)
        );

        this.selectItens = this.certifiers
          .map(certifier => ({
            inputId: certifier.certifierIdentifier,
            label: this.resolveCertifierDisplayName(certifier),
            data: certifier.certifierCode
          }))
          .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
      },
    });
  }

  private resolveCertifierDisplayName(certifier: {
    certifierCode?: string;
    certifierName?: string;
    certifierIdentifier?: number;
  }): string {
    if (this.isCdmCertifierIdentity(certifier)) {
      return CreditRegisterComponent.CDM_CERTIFIER_DISPLAY_NAME;
    }

    return String(certifier.certifierName ?? '');
  }

  private waitForMenuLoadedAndLoadCertifiers(): void {
    this.menuService.whenMenuLoaded$().subscribe(() => this.loadCertifiers());
  }

  onChangeCertifier(certifier: B3SelectItem | null | undefined): void {
    if (certifier) {
      this.selectedItem = certifier;
    } else {
      this.selectedItem = { inputId: 0, label: '', data: '' };
    }
    this.updateCertifierMode(certifier ?? null);
  }

  private updateCertifierMode(certifier: B3SelectItem | null): void {
    this.isCdmCertifierSelected = this.isCdmCertifier(certifier);

    const brcerControl = this.formRegister.get('brcerAccepted');
    const aceiteControl = this.formRegister.get('aceiteAccepted');
    const serialStartControl = this.formRegister.get('serialCodeStart');
    const serialEndControl = this.formRegister.get('serialCodeEnd');
    const serialCodeControl = this.formRegister.get('serialCode');

    if (this.isCdmCertifierSelected) {
      brcerControl?.clearValidators();
      aceiteControl?.setValidators([Validators.requiredTrue]);
      serialStartControl?.setValidators([Validators.required, Validators.maxLength(100)]);
      serialEndControl?.setValidators([Validators.required, Validators.maxLength(100)]);
      serialCodeControl?.clearValidators();
      serialCodeControl?.setValue('', { emitEvent: false });
    } else {
      brcerControl?.clearValidators();
      aceiteControl?.clearValidators();
      serialStartControl?.clearValidators();
      serialEndControl?.clearValidators();
      serialCodeControl?.setValidators([Validators.required, Validators.maxLength(100)]);

      brcerControl?.setValue(false, { emitEvent: false });
      aceiteControl?.setValue(false, { emitEvent: false });
      serialStartControl?.setValue('', { emitEvent: false });
      serialEndControl?.setValue('', { emitEvent: false });
    }

    brcerControl?.updateValueAndValidity({ emitEvent: false });
    aceiteControl?.updateValueAndValidity({ emitEvent: false });
    serialStartControl?.updateValueAndValidity({ emitEvent: false });
    serialEndControl?.updateValueAndValidity({ emitEvent: false });
    serialCodeControl?.updateValueAndValidity({ emitEvent: false });
  }

  private isCdmCertifier(certifier?: B3SelectItem | null): boolean {
    const formCertifier = this.formRegister.get('certifier')?.value;
    const resolved = certifier ?? formCertifier ?? null;

    if (!resolved || typeof resolved === 'string') {
      return false;
    }

    return this.isCdmCertifierIdentity({
      certifierCode: resolved.data,
      certifierName: resolved.label,
      certifierIdentifier: resolved.inputId,
    });
  }

  private isCdmCertifierIdentity(certifier: {
    certifierCode?: string | number | null;
    certifierName?: string | null;
    certifierIdentifier?: string | number | null;
  }): boolean {
    const certifierCode = String(certifier.certifierCode ?? '').toLowerCase();
    const certifierLabel = String(certifier.certifierName ?? '').toLowerCase();
    const certifierId = Number(certifier.certifierIdentifier);

    return CreditRegisterComponent.CDM_CERTIFIER_CODES.has(certifierCode)
      || certifierId === CreditRegisterComponent.CDM_CERTIFIER_ID
      || certifierLabel.includes('cdm')
      || certifierLabel.includes('mdl')
      || certifierLabel.includes('clean development')
      || certifierLabel.includes('mecanismo de desenvolvimento limpo');
  }

  private syncSerialCodeFromParts(): void {
    if (!this.isCdmCertifierSelected) {
      return;
    }

    const serialStart = String(this.formRegister.get('serialCodeStart')?.value ?? '').trim();
    const serialEnd = String(this.formRegister.get('serialCodeEnd')?.value ?? '').trim();
    this.formRegister.get('serialCode')?.setValue(`${serialStart}${serialEnd}`, { emitEvent: false });
  }

  onBlurDefault(date: Date) {
    this.formRegister.get("data")?.setValue(date);
    this.defaultRegistryDate = false;
    this.isInvalidRegistryDate = date > this.today || date < this.minDate;
  }

  onBlurStartDefault(date: Date) {
    this.formRegister.get("safraIDate")?.setValue(date);
    this.registrationStartDate = date;
    this.defaultStartDate = false;
    this.invalidStartDate = date > this.today || date < this.minDate || date > this.registrationEndDate;
  }

  onBlurEndDefault(date: Date) {
    this.formRegister.get("safraFDate")?.setValue(date);
    this.registrationEndDate = date;
    this.defaultEndDate = false;
    this.invalidEndDate = date > this.today || date < this.minDate || date < this.registrationStartDate;
  }

  onRegistryDateChange(event: Event): void {
    const iso = (event as CustomEvent<{ value?: string }>).detail?.value ?? '';
    const date = iso ? this.fromIsoDate(iso) : null;
    if (!date) {
      return;
    }
    this.defaultRegistryDate = false;
    this.isInvalidRegistryDate = date > this.today || date < this.minDate;
  }

  onSafraStartDateChange(event: Event): void {
    const iso = (event as CustomEvent<{ value?: string }>).detail?.value ?? '';
    const date = iso ? this.fromIsoDate(iso) : null;
    if (!date) {
      return;
    }
    this.registrationStartDate = date;
    this.defaultStartDate = false;
    this.invalidStartDate = date > this.today || date < this.minDate || date > this.registrationEndDate;
  }

  onSafraEndDateChange(event: Event): void {
    const iso = (event as CustomEvent<{ value?: string }>).detail?.value ?? '';
    const date = iso ? this.fromIsoDate(iso) : null;
    if (!date) {
      return;
    }
    this.registrationEndDate = date;
    this.defaultEndDate = false;
    this.invalidEndDate = date > this.today || date < this.minDate || date < this.registrationStartDate;
  }

  onBrcerAcceptedChange(event: Event): void {
    const selected = !!(event as CustomEvent<{ selected?: boolean }>).detail?.selected;
    const control = this.formRegister.get('brcerAccepted');
    control?.setValue(selected);
    control?.markAsTouched();
  }

  onAceiteAcceptedChange(event: Event): void {
    const selected = !!(event as CustomEvent<{ selected?: boolean }>).detail?.selected;
    const control = this.formRegister.get('aceiteAccepted');
    control?.setValue(selected);
    control?.markAsTouched();
  }

  private toIsoDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private fromIsoDate(iso: string): Date | null {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    if (!match) {
      return null;
    }

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const date = new Date(year, month - 1, day);

    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return null;
    }

    return date;
  }

  public onCancel(): void {
    this.goBack();
  }

  public goBack(): void {
    const currentUrl = this.router.url;

    if (window.history.length > 1) {
      this.location.back();

      // If there is no previous in-app navigation, fallback to a known screen.
      setTimeout(() => {
        if (this.router.url === currentUrl) {
          this.router.navigateByUrl('/consulta-caracteristicas');
        }
      }, 50);
      return;
    }

    this.router.navigateByUrl('/consulta-caracteristicas');
  }

  public cleanForm(): void {
    this.formRegister.reset(undefined, { emitEvent: false });
    this.resetFormInteractionState();
    this.selectedItem = { inputId: 0, label: '', data: '' };
    this.updateCertifierMode(null);
    this.applyHolderCpfCnpjValidators('');
    this.comitenteFound = false;
    this.isCdmCertifierSelected = false;
    this.lastRegistrationWasCdm = false;
    this.defaultRegistryDate = true;
    this.defaultStartDate = true;
    this.defaultEndDate = true;
    this.invalidEndDate = false;
    this.invalidStartDate = false;
    this.isInvalidRegistryDate = false;

    queueMicrotask(() => this.resetFormInteractionState());
  }

  private resetFormInteractionState(): void {
    this.formRegister.markAsPristine();
    this.formRegister.markAsUntouched();

    Object.values(this.formRegister.controls).forEach(control => {
      control.markAsPristine();
      control.markAsUntouched();
    });
  }

  public async onRegisterClick(): Promise<void> {
    if (this.isButtonDisabled) {
      return;
    }

    this.formRegister.markAllAsTouched();
    await this.waitForFormValidation();

    if (!this.formRegister.valid) {
      const fieldWithError = this.getFirstInvalidField();
      this.showFieldErrorModal(fieldWithError ?? {
        fieldName: 'form',
        fieldLabel: 'Formulário',
        errors: { required: true },
      });
      return;
    }

    if (this.shouldBlockAccountType10Registration()) {
      this.showAccountType10BlockModal(this.getAccountType10BlockMessage());
      return;
    }

    await this.creditRegister();
  }

  private async waitForFormValidation(): Promise<void> {
    if (!this.formRegister.pending) {
      return;
    }

    await firstValueFrom(
      this.formRegister.statusChanges.pipe(
        filter(status => status !== 'PENDING'),
        take(1),
      ),
    );
  }

  private applyHolderCpfCnpjValidators(holderNumber?: string | null): void {
    const accountType = this.getHolderAccountType(holderNumber);
    const control = this.formRegister.get('holderCpfCnpj');

    this.showHolderCpfCnpj = accountType === CreditRegisterComponent.HOLDER_ACCOUNT_TYPE_ACX;

    if (this.showHolderCpfCnpj) {
      control?.setValidators([Validators.required, CpfCnpjValidator.validate]);
      control?.setAsyncValidators([
        comitenteBackendValidator(
          this.creditRegisterService,
          () => this.formRegister.get('holderNumber')?.value,
        ),
      ]);
    } else {
      control?.clearValidators();
      control?.clearAsyncValidators();
      control?.setValue('');
      this.comitenteFound = false;
    }

    control?.updateValueAndValidity();
  }

  private getFirstInvalidField(): { fieldName: string; fieldLabel: string; errors: any } | null {
    const formControls = this.formRegister.controls;

    const holderCpfCnpjControl = formControls['holderCpfCnpj'];
    if (holderCpfCnpjControl?.invalid && holderCpfCnpjControl?.errors?.['comitenteInvalido']) {
      return {
        fieldName: 'holderCpfCnpj',
        fieldLabel: this.getFieldLabel('holderCpfCnpj'),
        errors: holderCpfCnpjControl.errors
      };
    }

    for (const fieldName in formControls) {
      const control = formControls[fieldName];
      if (control.invalid) {
        const fieldLabel = this.getFieldLabel(fieldName);
        return {
          fieldName,
          fieldLabel,
          errors: control.errors
        };
      }
    }

    return null;
  }

  private getFieldLabel(fieldName: string): string {
    const labels: { [key: string]: string } = {
      "cnpj": "CNPJ do Registrador",
      "registerNumber": "Conta Registrador",
      "holderNumber": "Conta Detentor",
      "holderCpfCnpj": "CPF/CNPJ do Comitente",
      "data": "Data de Emissão",
      "safraIDate": "Data Inicial da Safra",
      "safraFDate": "Data Final da Safra",
      "projectName": "Nome do Projeto",
      "projectId": "ID do Projeto",
      "projectLink": "Link do Projeto",
      "certifier": "Certificadora",
      "serialCode": "Serial Range / Credit ID",
      "creditQuantity": "Quantidade de Créditos",
      "description": "Descrição do Projeto"
    };

    return labels[fieldName] || fieldName;
  }

  private showFieldErrorModal(field: { fieldName: string; fieldLabel: string; errors: any }): void {
    let errorMessage = this.FIELD_ERROR_MESSAGES[field.fieldName] || `Campo ${field.fieldLabel} é inválido.`;

    if (field.errors['required']) {
      errorMessage = `${field.fieldLabel} é obrigatório.`;
    } else if (field.errors['emissionAfterSafraStart']) {
      errorMessage = 'Data da emissão não pode ser posterior à data da safra';
    } else if (field.errors['comitenteInvalido']) {
      const documentNumber = this.formRegister.get('holderCpfCnpj')?.value;
      const accountCode = this.formRegister.get('holderNumber')?.value;
      errorMessage = `CPF/CNPJ do Comitente: ${documentNumber}\nConta do Detentor: ${accountCode}\n\n${CreditRegisterComponent.INVESTOR_NOT_FOUND_MESSAGE}`;
    } else if (field.errors['minlength']) {
      errorMessage = `${field.fieldLabel} deve ter no mínimo ${field.errors['minlength'].requiredLength} caracteres.`;
    } else if (field.errors['maxlength']) {
      errorMessage = `${field.fieldLabel} deve ter no máximo ${field.errors['maxlength'].requiredLength} caracteres.`;
    } else if (field.errors['pattern']) {
      errorMessage = `${field.fieldLabel} tem um formato inválido.`;
    } else {
      errorMessage = `${field.fieldLabel}\n\n${errorMessage}`;
    }

    this.openInfoModal('Campo inválido', errorMessage, 'error', 'danger');
  }

  private openInfoModal(
    title: string,
    message: string,
    icon = 'info',
    iconTone: CreditRegisterInfoViewModel['iconTone'] = 'info',
  ): void {
    this.infoViewModel = { title, message, icon, iconTone };
    this.showInfoModal = true;
  }

  onSuccessModalAction(action: 'new-register' | 'consult' | 'dismiss'): void {
    this.showSuccessModal = false;
    this.successViewModel = null;

    if (action === 'new-register') {
      this.cleanForm();
    }

    if (action === 'consult') {
      this.router.navigate([this.consultRoute]);
    }
  }

  onErrorModalAction(): void {
    this.showErrorModal = false;
    this.errorViewModel = null;
  }

  onInfoModalAction(): void {
    this.showInfoModal = false;
    this.infoViewModel = null;
  }

  public async creditRegister(): Promise<void> {
    this.isButtonDisabled = true;
    this.syncSerialCodeFromParts();
    this.lastRegistrationWasCdm = this.isCdmCertifierSelected;

    try {
      const res: CarbonCreditResponse = await firstValueFrom(this.creditRegisterService.creditRegister(this.formRegister.value));
      this.treatCreditRecordSuccess(res);
    } catch (erro) {
      this.treatCreditRecordError(erro);
    } finally {
      this.isButtonDisabled = false;
    }
  }

  public treatCreditRecordSuccess(res: CarbonCreditResponse): void {
    const flowType: CreditRegisterSuccessFlow = res.data.sentToAcx
      ? 'acx'
      : (this.lastRegistrationWasCdm ? 'cdm' : 'b3');

    this.successViewModel = buildCreditRegisterSuccessViewModel(res, flowType);
    this.showSuccessModal = true;
    this.cleanForm();
  }

  public treatCreditRecordError(erro: any): void {
    let title = 'Erro ao registrar';
    let errorMessage = 'Ocorreu um erro ao tentar registrar os créditos. Por favor, tente novamente.';
    console.error('Erro ao registrar créditos:', erro);
    errorMessage = this.buildErrorMessage(erro, errorMessage);
    this.openErrorModal(erro, title, errorMessage);
  }

private buildErrorMessage(erro: any, defaultMessage: string): string {
  if (typeof erro === 'string') {
    return this.ERROR_MESSAGES[erro] ?? `Erro: ${erro}`;
  }

  const apiError = this.extractApiErrorItem(erro);
  if (apiError) {
    return this.resolveApiErrorMessage(apiError, defaultMessage);
  }

  return defaultMessage;
}

private extractApiErrorItem(erro: any): { code?: string; message?: string; details?: string } | null {
  if (erro?.code) {
    return erro;
  }

  const errorData = erro?.error;
  if (!errorData) {
    return null;
  }

  if (Array.isArray(errorData)) {
    return errorData[0] ?? null;
  }

  if (typeof errorData === 'object' && errorData.code) {
    return errorData;
  }

  return null;
}

private resolveApiErrorMessage(
  apiError: { code?: string; message?: string; details?: string },
  defaultMessage: string,
): string {
  if (apiError.code === 'CarbonCreditRegisterError') {
    return this.resolveCarbonCreditRegisterErrorMessage(apiError);
  }

  const mappedMessage = apiError.code ? this.ERROR_MESSAGES[apiError.code] : undefined;
  if (mappedMessage) {
    return mappedMessage;
  }

  return apiError.message ?? defaultMessage;
}

private resolveCarbonCreditRegisterErrorMessage(errorItem: {
  message?: string;
  details?: string;
}): string {
  if (this.isInvalidSerialRangeDetails(errorItem.details)) {
    return CreditRegisterComponent.INVALID_SERIAL_RANGE_MESSAGE;
  }

  if (errorItem.message) {
    return errorItem.message;
  }

  return this.ERROR_MESSAGES['CarbonCreditRegisterError'];
}

private isInvalidSerialRangeDetails(details?: string | null): boolean {
  if (!details) {
    return false;
  }

  const normalized = details.toLowerCase();
  return CreditRegisterComponent.INVALID_SERIAL_RANGE_DETAIL_KEYWORDS.some(keyword =>
    normalized.includes(keyword),
  );
}

private extractApiErrorCode(erro: any): string | undefined {
  if (typeof erro === 'string') {
    return erro;
  }

  if (erro?.code) {
    return erro.code;
  }

  const errorData = erro?.error;
  if (Array.isArray(errorData)) {
    return errorData[0]?.code;
  }

  if (errorData?.code) {
    return errorData.code;
  }

  return undefined;
}

  private openErrorModal(erro: any, title: string, errorMessage: string): void {
    const errorCode = this.extractApiErrorCode(erro);

    if (errorCode === 'CarbonCreditRegisterError' || errorCode === 'CommunicationErrorAcx' || errorCode === 'CommunicationErrorMdl') {
      this.errorViewModel = {
        title: 'Erro!',
        description: errorMessage,
      };
      this.showErrorModal = true;
      return;
    }

    this.openInfoModal(title, errorMessage, 'error', 'danger');
  }

  public treatCreditRecordErrorEmptyCpfField(): void {
    this.openInfoModal(
      'Erro',
      'Favor verificar, Detentor com conta 00000.10-0 Campo CNPJ obrigatório',
      'error',
      'danger',
    );
  }

  public onChangesInputCpfOrCnpj(): void {
    const control = this.formRegister.get('cnpj');
    this.syncRegistrarDocumentControlValue(control?.value, true);
  }

  public onChangesHolderCpfOrCnpj(): void {
    const control = this.formRegister.get('holderCpfCnpj');
    const next = formatCpfCnpjInputValue(control?.value, true);
    if (control?.value !== next) {
      control?.setValue(next);
    }
  }

  private shouldFormatRegistrarDocumentOnInput(value: string | null | undefined): boolean {
    return extractDocumentCharacters(value).length > 0;
  }

  private normalizeRegistrarDocumentValue(raw: string | null | undefined, formatWhenComplete = false): string {
    const alnum = extractDocumentCharacters(raw).slice(0, 14);
    if (!alnum) {
      return '';
    }

    if (formatWhenComplete) {
      return formatCNPJProgressive(alnum);
    }

    return alnum;
  }

  private syncRegistrarDocumentControlValue(raw: string | null | undefined, formatWhenComplete = false): void {
    const control = this.formRegister.get('cnpj');
    const nextValue = this.normalizeRegistrarDocumentValue(raw, formatWhenComplete);
    const currentAlnum = extractDocumentCharacters(control?.value);
    const nextAlnum = extractDocumentCharacters(nextValue);

    if (currentAlnum === nextAlnum && String(control?.value ?? '') === nextValue) {
      return;
    }

    control?.setValue(nextValue, { emitEvent: false });
  }

  /** Durante a digitação: não formata CPF no 11º dígito (permite continuar para CNPJ). */
  private syncHolderDocumentControlValue(raw: string | null | undefined): void {
    const control = this.formRegister.get('holderCpfCnpj');
    const alnum = extractDocumentCharacters(raw).slice(0, 14);

    if (!alnum) {
      if (control?.value) {
        control.setValue('', { emitEvent: false });
      }
      return;
    }

    let nextValue: string;
    if (alnum.length >= 12) {
      nextValue = formatCNPJProgressive(alnum);
    } else if (alnum.length === 11 && /[.\-/]/.test(String(raw ?? ''))) {
      nextValue = formatCpfCnpjInputValue(raw, true);
    } else {
      nextValue = alnum;
    }

    const currentAlnum = extractDocumentCharacters(control?.value);
    const isCompleteDocument = alnum.length === 11 || alnum.length === 14;

    if (currentAlnum === alnum && String(control?.value ?? '') === nextValue) {
      return;
    }

    // emitEvent true quando documento completo para statusChanges disparar após validação backend
    control?.setValue(nextValue, { emitEvent: isCompleteDocument });
  }

  private updateComitenteFoundState(): void {
    const control = this.formRegister.get('holderCpfCnpj');

    if (!control || !this.showHolderCpfCnpj) {
      this.comitenteFound = false;
      return;
    }

    const digits = String(control.value ?? '').replace(/\D/g, '');
    const hasFullDocument = digits.length === 11 || digits.length === 14;

    this.comitenteFound = hasFullDocument
      && control.status === 'VALID'
      && control.valid
      && !control.hasError('comitenteInvalido')
      && !control.hasError('backendError');
  }

  private getHolderAccountType(holderNumber?: string | null): string | null {
    if (!holderNumber || holderNumber.length < 8) {
      return null;
    }

    return holderNumber.substring(6, 8);
  }

  private isHolderAccountType10(): boolean {
    return this.getHolderAccountType(this.formRegister.get('holderNumber')?.value) === CreditRegisterComponent.HOLDER_ACCOUNT_TYPE_ACX;
  }

  private isAcxBlockedCertifier(): boolean {
    const certifier = this.formRegister.get('certifier')?.value;
    const certifierCode = String(certifier?.data ?? this.selectedItem?.data ?? '').toLowerCase();
    const certifierId = Number(certifier?.inputId ?? this.selectedItem?.inputId);

    return CreditRegisterComponent.ACX_BLOCKED_CERTIFIER_CODES.has(certifierCode)
      || CreditRegisterComponent.ACX_BLOCKED_CERTIFIER_IDS.has(certifierId);
  }

  private shouldBlockAccountType10Registration(): boolean {
    if (!this.isHolderAccountType10()) {
      return false;
    }

    if (this.isAcxBlockedCertifier()) {
      return true;
    }

    return this.isCdmCertifier() && this.loggedInService.isExplicitlyExternalUser();
  }

  private getAccountType10BlockMessage(): string {
    if (this.isCdmCertifier()) {
      return CreditRegisterComponent.CDM_ACCOUNT_TYPE_NOT_AVAILABLE_MESSAGE;
    }

    return CreditRegisterComponent.ACX_ACCOUNT_TYPE_NOT_AVAILABLE_MESSAGE;
  }

  private showAccountType10BlockModal(message: string): void {
    this.openInfoModal('Erro ao registrar', message, 'error', 'danger');
  }

  noWhitespaceValidator(control: AbstractControl) {
    const isWhitespace = (control.value || '').indexOf(' ') >= 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  protected convertDateFormat(dateString: string): string {
    if (dateString.length !== 8) {
      dateString = "00000000";
    }

    const day = dateString.substring(0, 2);
    const month = dateString.substring(2, 4);
    const year = dateString.substring(4, 8);

    return `${year}-${month}-${day}`;
  }

  protected validateSerialCodeByRegex(serialCode: string, regexPattern: string) {
    const regex = new RegExp(regexPattern);
    return regex.test(serialCode);
  }

  public formatErrorMessage(template: string, value: string): string {
    const replaceTemplate: string = template.replace('{0}', value);
    const formattedMessage = replaceTemplate.replace(/\s+/g, ' ').trim();
    return formattedMessage;
  }
}
